export const isSentryAvailable = () => {
    return Boolean(window && window.Sentry);
};

export const normalizeError = (error: unknown): Error => {
    if (error instanceof Error) return error;
    if (typeof error === 'string') return new Error(error);

    return new Error(`Failed to normalize error with typeof ${typeof error}`);
};
